/**
 * @ngdoc directive
 * @name googleplaces
 *
 * @description
 * Google Places autocomplete
 * Base on :
 * angular-google-places-autocomplete
 *
 * Copyright (c) 2014 "kuhnza" David Kuhn
 * Licensed under the MIT license.
 * https://github.com/kuhnza/angular-google-places-autocomplete/blob/master/LICENSE
 */
module
.directive('googlePlacesAutocomplete', ['$parse', '$compile', '$timeout', '$document', 'googlePlacesApi',
  function ($parse, $compile, $timeout, $document, google) {
  return {
    restrict: 'A',
    require: '^ngModel',
    scope: {
      model: '=ngModel'
    },
    link: function($scope, element, attrs, controller) {
      var keymap = {
          tab: 9,
          enter: 13,
          esc: 27,
          up: 38,
          down: 40
      };
      var hotkeys = [keymap.tab, keymap.enter, keymap.esc, keymap.up, keymap.down];
      var autocompleteService = new google.maps.places.AutocompleteService();
      var placesService = new google.maps.places.PlacesService(element[0]);

      (function() {
          $scope.query = '';
          $scope.predictions = [];
          $scope.input = element;

          initAutocompleteDrawer();
          initEvents();
          initNgModelController();
      }());


      function initNgModelController() {
        controller.$parsers.push(parse);
        controller.$formatters.push(format);
        controller.$render = render;
      }

      function initEvents() {
          element.bind('keydown', onKeydown);
          element.bind('blur', onBlur);
          element.bind('submit', onBlur);

          $scope.$watch('selected', select);
      }

      /* Events handler : keydown */
      function onKeydown(event) {
        if ($scope.predictions.length === 0 || hotkeys.indexOf(event.which) === -1) {
            return;
        }
        event.preventDefault();

        if (event.which === keymap.down) {
          $scope.active = ($scope.active + 1) % $scope.predictions.length;
          $scope.$digest();
        } else if (event.which === keymap.up) {
          $scope.active = ($scope.active ? $scope.active : $scope.predictions.length) - 1;
          $scope.$digest();
        } else if (event.which === 13 || event.which === 9) {
          if ($scope.forceSelection) {
            $scope.active = ($scope.active === -1) ? 0 : $scope.active;
          }

          $scope.$apply(function () {
            $scope.selected = $scope.active;

              if ($scope.selected === -1) {
                clearPredictions();
              }
          });
        } else if (event.which === 27) {
          $scope.$apply(function () {
            event.stopPropagation();
            clearPredictions();
          });
        }
      }

      /* Events handler : blur */
      function onBlur() {
        if ($scope.predictions.length === 0) {
          return;
        }

        if ($scope.forceSelection) {
          $scope.selected = ($scope.selected === -1) ? 0 : $scope.selected;
        }

        $scope.$digest();

        $scope.$apply(function () {
          if ($scope.selected === -1) {
            clearPredictions();
          }
        });
      }

      // drawzer
      function initAutocompleteDrawer() {
        // Drawer element used to display predictions
        var drawerElement = angular.element('<div google-places-autocomplete-drawer></div>');
        var body = angular.element($document[0].body);
        var $drawer;

        drawerElement.attr({
          input: 'input',
          query: 'query',
          predictions: 'predictions',
          active: 'active',
          selected: 'selected'
        });

        $drawer = $compile(drawerElement)($scope);
        body.append($drawer);  // Append to DOM

        $scope.$on('$destroy', function() {
          $drawer.remove();
        });
      }

      /* render result */
      function render() {
        return element.val(controller.$viewValue);
      }

      /* cleanup */
      function clearPredictions() {
        $scope.active = -1;
        $scope.selected = -1;
        $scope.predictions = [];
      }

      /* choice handler */
      function select() {
        var prediction = $scope.predictions[$scope.selected];
        if (!prediction) {
          return;
        }
        element.addClass('is-waiting');
        placesService.getDetails({ placeId: prediction.place_id }, function (place, status) {
          element.removeClass('is-waiting');

          if (status === google.maps.places.PlacesServiceStatus.OK) {
            $scope.$apply(function () {
              $scope.model = place;
              $scope.$emit('google-places-autocomplete:select', place);
              $timeout(function () {
                controller.$viewChangeListeners.forEach(function (fn) { fn(); });
              });
            });
          }
          });

        clearPredictions();
      }

      /* result parser*/
      function parse(viewValue) {
        var request;

        if (!(viewValue && isString(viewValue))) {
          return viewValue;
        }

        $scope.query = viewValue;

        request = angular.extend({ input: viewValue }, $scope.options);

        autocompleteService.getPlacePredictions(request, function (predictions, status) {

          $scope.$apply(function () {
            clearPredictions();

            if (status === google.maps.places.PlacesServiceStatus.OK) {
              $scope.predictions.push.apply($scope.predictions, predictions);
            }

            if ($scope.predictions.length > 5) {
              $scope.predictions.length = 5;  // trim predictions down to size
            }
          });
        });

        return viewValue;
      }

      /* adress model parser */
      function formatAdress(modelAdress) {
        var result = {};
        var i, l;
        if (!modelAdress.address_components) {
          return modelAdress.formatted_address;
        }
        l = modelAdress.address_components.length;
        for(i = 0; i < l; i++) {
          result[modelAdress.address_components[i].types[0]] = modelAdress.address_components[i].long_name;
        }
        return (result.street_number ? result.street_number + ' ' : '') + result.route;
      }

      /* formater */
      function format(modelValue) {
        var viewValue = "";

        if (isString(modelValue)) {
          viewValue = modelValue;
        } else if (isObject(modelValue)) {
          viewValue = formatAdress(modelValue)
        }

        return viewValue;
      }

      /* format tester */
      function isString(val) {
        return Object.prototype.toString.call(val) === '[object String]';
      }
      function isObject(val) {
        return Object.prototype.toString.call(val) === '[object Object]';
      }
    }
  };
}])
.directive('googlePlacesAutocompleteDrawer', ['$window', '$document', function ($window, $document) {

  return {
    restrict: 'A',
    scope:{
      input: '=',
      query: '=',
      predictions: '=',
      active: '=',
      selected: '='
    },
    link: function ($scope, element) {
      element.bind('mousedown', function (event) {
        event.preventDefault();  // prevent blur event from firing when clicking selection
      });

      /* screen resolution changes detection */
      $window.onresize = function () {
        $scope.$apply(function () {
          $scope.position = getDrawerPosition($scope.input);
        });
      };
      $scope.isOpen = function () {
        return $scope.predictions.length > 0;
      };

      $scope.isActive = function (index) {
        return $scope.active === index;
      };

      $scope.selectActive = function (index) {
        $scope.active = index;
      };

      $scope.selectPrediction = function (index) {
        $scope.selected = index;
      };

      $scope.$watch('predictions', function () {
        $scope.position = getDrawerPosition($scope.input);
      }, true);

      function getDrawerPosition(element) {
          var domEl = element[0],
              rect = domEl.getBoundingClientRect(),
              docEl = $document[0].documentElement,
              body = $document[0].body,
              scrollTop = $window.pageYOffset || docEl.scrollTop || body.scrollTop,
              scrollLeft = $window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

          return {
              width: rect.width,
              height: rect.height,
              top: rect.top + rect.height + scrollTop,
              left: rect.left + scrollLeft
          };
      }

    },
    template:
      '<div class="pac-container" ng-if="isOpen()" ng-style="{top: position.top+\'px\', left: position.left+\'px\', width: position.width+\'px\'}" style="display: block;" role="listbox" aria-hidden="{{!isOpen()}}">' +
      '  <div class="pac-item" google-places-autocomplete-prediction index="$index" prediction="prediction" query="query"' +
      '       ng-repeat="prediction in predictions track by $index" ng-class="{\'pac-item-selected\': isActive($index) }"' +
      '       ng-mouseenter="selectActive($index)" ng-click="selectPrediction($index)" role="option" id="{{prediction.id}}">' +
      '  </div>' +
      '</div>'
  };
}])
.directive('googlePlacesAutocompletePrediction', [function () {
  return {
      restrict: 'A',
      scope:{
          index:'=',
          prediction:'=',
          query:'='
      },
      template:
        '<span class="pac-icon pac-icon-marker"></span>' +
        '<span class="pac-item-query" ng-bind-html="prediction | highlightMatched"></span>' +
        '<span ng-repeat="term in prediction.terms | unmatchedTermsOnly:prediction">{{term.value | trailingComma:!$last}}&nbsp;</span>'
  };
}])
.filter('highlightMatched', ['$sce', function ($sce) {
  return function (prediction) {
    var matchedPortion = '';
    var unmatchedPortion = '';
    var matched;

    if (prediction.matched_substrings.length > 0 && prediction.terms.length > 0) {
        matched = prediction.matched_substrings[0];
        matchedPortion = prediction.terms[0].value.substr(matched.offset, matched.length);
        unmatchedPortion = prediction.terms[0].value.substr(matched.offset + matched.length);
    }

    return $sce.trustAsHtml('<span class="pac-matched">' + matchedPortion + '</span>' + unmatchedPortion);
  };
}])
.filter('unmatchedTermsOnly', [function () {
  return function (terms, prediction) {
    var i, term, filtered = [];

    for (i = 0; i < terms.length; i++) {
      term = terms[i];
      if (prediction.matched_substrings.length > 0 && term.offset > prediction.matched_substrings[0].length) {
        filtered.push(term);
      }
    }

    return filtered;
  };
}])
.filter('trailingComma', [function () {
  return function (input, condition) {
    return (condition) ? input + ',' : input;
  };
}]);